/* eslint-disable no-template-curly-in-string */
import { AndroidOutlined, AppleOutlined, DesktopOutlined, MobileOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

export const CURRENCIES = [
  { cc: "AED", symbol: "\u062f.\u0625;", name: "UAE dirham" },
  { cc: "AFN", symbol: "Afs", name: "Afghan afghani" },
  { cc: "ALL", symbol: "L", name: "Albanian lek" },
  { cc: "AMD", symbol: "AMD", name: "Armenian dram" },
  { cc: "ANG", symbol: "NA\u0192", name: "Netherlands Antillean gulden" },
  { cc: "AOA", symbol: "Kz", name: "Angolan kwanza" },
  { cc: "ARS", symbol: "$", name: "Argentine peso" },
  { cc: "AUD", symbol: "$", name: "Australian dollar" },
  { cc: "AWG", symbol: "\u0192", name: "Aruban florin" },
  { cc: "AZN", symbol: "AZN", name: "Azerbaijani manat" },
  { cc: "BAM", symbol: "KM", name: "Bosnia and Herzegovina konvertibilna marka" },
  { cc: "BBD", symbol: "Bds$", name: "Barbadian dollar" },
  { cc: "BDT", symbol: "\u09f3", name: "Bangladeshi taka" },
  { cc: "BGN", symbol: "BGN", name: "Bulgarian lev" },
  { cc: "BHD", symbol: ".\u062f.\u0628", name: "Bahraini dinar" },
  { cc: "BIF", symbol: "FBu", name: "Burundi franc" },
  { cc: "BMD", symbol: "BD$", name: "Bermudian dollar" },
  { cc: "BND", symbol: "B$", name: "Brunei dollar" },
  { cc: "BOB", symbol: "Bs.", name: "Bolivian boliviano" },
  { cc: "BRL", symbol: "R$", name: "Brazilian real" },
  { cc: "BSD", symbol: "B$", name: "Bahamian dollar" },
  { cc: "BTN", symbol: "Nu.", name: "Bhutanese ngultrum" },
  { cc: "BWP", symbol: "P", name: "Botswana pula" },
  { cc: "BYR", symbol: "Br", name: "Belarusian ruble" },
  { cc: "BZD", symbol: "BZ$", name: "Belize dollar" },
  { cc: "CAD", symbol: "$", name: "Canadian dollar" },
  { cc: "CDF", symbol: "F", name: "Congolese franc" },
  { cc: "CHF", symbol: "Fr.", name: "Swiss franc" },
  { cc: "CLP", symbol: "$", name: "Chilean peso" },
  { cc: "CNY", symbol: "\u00a5", name: "Chinese/Yuan renminbi" },
  { cc: "COP", symbol: "Col$", name: "Colombian peso" },
  { cc: "CRC", symbol: "\u20a1", name: "Costa Rican colon" },
  { cc: "CUC", symbol: "$", name: "Cuban peso" },
  { cc: "CVE", symbol: "Esc", name: "Cape Verdean escudo" },
  { cc: "CZK", symbol: "K\u010d", name: "Czech koruna" },
  { cc: "DJF", symbol: "Fdj", name: "Djiboutian franc" },
  { cc: "DKK", symbol: "Kr", name: "Danish krone" },
  { cc: "DOP", symbol: "RD$", name: "Dominican peso" },
  { cc: "DZD", symbol: "\u062f.\u062c", name: "Algerian dinar" },
  { cc: "EEK", symbol: "KR", name: "Estonian kroon" },
  { cc: "EGP", symbol: "\u00a3", name: "Egyptian pound" },
  { cc: "ERN", symbol: "Nfa", name: "Eritrean nakfa" },
  { cc: "ETB", symbol: "Br", name: "Ethiopian birr" },
  { cc: "EUR", symbol: "\u20ac", name: "European Euro" },
  { cc: "FJD", symbol: "FJ$", name: "Fijian dollar" },
  { cc: "FKP", symbol: "\u00a3", name: "Falkland Islands pound" },
  { cc: "GBP", symbol: "\u00a3", name: "British pound" },
  { cc: "GEL", symbol: "GEL", name: "Georgian lari" },
  { cc: "GHS", symbol: "GH\u20b5", name: "Ghanaian cedi" },
  { cc: "GIP", symbol: "\u00a3", name: "Gibraltar pound" },
  { cc: "GMD", symbol: "D", name: "Gambian dalasi" },
  { cc: "GNF", symbol: "FG", name: "Guinean franc" },
  { cc: "GQE", symbol: "CFA", name: "Central African CFA franc" },
  { cc: "GTQ", symbol: "Q", name: "Guatemalan quetzal" },
  { cc: "GYD", symbol: "GY$", name: "Guyanese dollar" },
  { cc: "HKD", symbol: "HK$", name: "Hong Kong dollar" },
  { cc: "HNL", symbol: "L", name: "Honduran lempira" },
  { cc: "HRK", symbol: "kn", name: "Croatian kuna" },
  { cc: "HTG", symbol: "G", name: "Haitian gourde" },
  { cc: "HUF", symbol: "Ft", name: "Hungarian forint" },
  { cc: "IDR", symbol: "Rp", name: "Indonesian rupiah" },
  { cc: "ILS", symbol: "\u20aa", name: "Israeli new sheqel" },
  { cc: "INR", symbol: "\u20B9", name: "Indian rupee" },
  { cc: "IQD", symbol: "\u062f.\u0639", name: "Iraqi dinar" },
  { cc: "IRR", symbol: "IRR", name: "Iranian rial" },
  { cc: "ISK", symbol: "kr", name: "Icelandic kr\u00f3na" },
  { cc: "JMD", symbol: "J$", name: "Jamaican dollar" },
  { cc: "JOD", symbol: "JOD", name: "Jordanian dinar" },
  { cc: "JPY", symbol: "\u00a5", name: "Japanese yen" },
  { cc: "KES", symbol: "KSh", name: "Kenyan shilling" },
  { cc: "KGS", symbol: "\u0441\u043e\u043c", name: "Kyrgyzstani som" },
  { cc: "KHR", symbol: "\u17db", name: "Cambodian riel" },
  { cc: "KMF", symbol: "KMF", name: "Comorian franc" },
  { cc: "KPW", symbol: "W", name: "North Korean won" },
  { cc: "KRW", symbol: "W", name: "South Korean won" },
  { cc: "KWD", symbol: "KWD", name: "Kuwaiti dinar" },
  { cc: "KYD", symbol: "KY$", name: "Cayman Islands dollar" },
  { cc: "KZT", symbol: "T", name: "Kazakhstani tenge" },
  { cc: "LAK", symbol: "KN", name: "Lao kip" },
  { cc: "LBP", symbol: "\u00a3", name: "Lebanese lira" },
  { cc: "LKR", symbol: "Rs", name: "Sri Lankan rupee" },
  { cc: "LRD", symbol: "L$", name: "Liberian dollar" },
  { cc: "LSL", symbol: "M", name: "Lesotho loti" },
  { cc: "LTL", symbol: "Lt", name: "Lithuanian litas" },
  { cc: "LVL", symbol: "Ls", name: "Latvian lats" },
  { cc: "LYD", symbol: "LD", name: "Libyan dinar" },
  { cc: "MAD", symbol: "MAD", name: "Moroccan dirham" },
  { cc: "MDL", symbol: "MDL", name: "Moldovan leu" },
  { cc: "MGA", symbol: "FMG", name: "Malagasy ariary" },
  { cc: "MKD", symbol: "MKD", name: "Macedonian denar" },
  { cc: "MMK", symbol: "K", name: "Myanma kyat" },
  { cc: "MNT", symbol: "\u20ae", name: "Mongolian tugrik" },
  { cc: "MOP", symbol: "P", name: "Macanese pataca" },
  { cc: "MRO", symbol: "UM", name: "Mauritanian ouguiya" },
  { cc: "MUR", symbol: "Rs", name: "Mauritian rupee" },
  { cc: "MVR", symbol: "Rf", name: "Maldivian rufiyaa" },
  { cc: "MWK", symbol: "MK", name: "Malawian kwacha" },
  { cc: "MXN", symbol: "$", name: "Mexican peso" },
  { cc: "MYR", symbol: "RM", name: "Malaysian ringgit" },
  { cc: "MZM", symbol: "MTn", name: "Mozambican metical" },
  { cc: "NAD", symbol: "N$", name: "Namibian dollar" },
  { cc: "NGN", symbol: "\u20a6", name: "Nigerian naira" },
  { cc: "NIO", symbol: "C$", name: "Nicaraguan c\u00f3rdoba" },
  { cc: "NOK", symbol: "kr", name: "Norwegian krone" },
  { cc: "NPR", symbol: "NRs", name: "Nepalese rupee" },
  { cc: "NZD", symbol: "NZ$", name: "New Zealand dollar" },
  { cc: "OMR", symbol: "OMR", name: "Omani rial" },
  { cc: "PAB", symbol: "B./", name: "Panamanian balboa" },
  { cc: "PEN", symbol: "S/.", name: "Peruvian nuevo sol" },
  { cc: "PGK", symbol: "K", name: "Papua New Guinean kina" },
  { cc: "PHP", symbol: "\u20b1", name: "Philippine peso" },
  { cc: "PKR", symbol: "Rs.", name: "Pakistani rupee" },
  { cc: "PLN", symbol: "z\u0142", name: "Polish zloty" },
  { cc: "PYG", symbol: "\u20b2", name: "Paraguayan guarani" },
  { cc: "QAR", symbol: "QR", name: "Qatari riyal" },
  { cc: "RON", symbol: "L", name: "Romanian leu" },
  { cc: "RSD", symbol: "din.", name: "Serbian dinar" },
  { cc: "RUB", symbol: "R", name: "Russian ruble" },
  { cc: "SAR", symbol: "SR", name: "Saudi riyal" },
  { cc: "SBD", symbol: "SI$", name: "Solomon Islands dollar" },
  { cc: "SCR", symbol: "SR", name: "Seychellois rupee" },
  { cc: "SDG", symbol: "SDG", name: "Sudanese pound" },
  { cc: "SEK", symbol: "kr", name: "Swedish krona" },
  { cc: "SGD", symbol: "S$", name: "Singapore dollar" },
  { cc: "SHP", symbol: "\u00a3", name: "Saint Helena pound" },
  { cc: "SLL", symbol: "Le", name: "Sierra Leonean leone" },
  { cc: "SOS", symbol: "Sh.", name: "Somali shilling" },
  { cc: "SRD", symbol: "$", name: "Surinamese dollar" },
  { cc: "SYP", symbol: "LS", name: "Syrian pound" },
  { cc: "SZL", symbol: "E", name: "Swazi lilangeni" },
  { cc: "THB", symbol: "\u0e3f", name: "Thai baht" },
  { cc: "TJS", symbol: "TJS", name: "Tajikistani somoni" },
  { cc: "TMT", symbol: "m", name: "Turkmen manat" },
  { cc: "TND", symbol: "DT", name: "Tunisian dinar" },
  { cc: "TRY", symbol: "TRY", name: "Turkish new lira" },
  { cc: "TTD", symbol: "TT$", name: "Trinidad and Tobago dollar" },
  { cc: "TWD", symbol: "NT$", name: "New Taiwan dollar" },
  { cc: "TZS", symbol: "TZS", name: "Tanzanian shilling" },
  { cc: "UAH", symbol: "UAH", name: "Ukrainian hryvnia" },
  { cc: "UGX", symbol: "USh", name: "Ugandan shilling" },
  { cc: "USD", symbol: "US$", name: "United States dollar" },
  { cc: "UYU", symbol: "$U", name: "Uruguayan peso" },
  { cc: "UZS", symbol: "UZS", name: "Uzbekistani som" },
  { cc: "VEB", symbol: "Bs", name: "Venezuelan bolivar" },
  { cc: "VND", symbol: "\u20ab", name: "Vietnamese dong" },
  { cc: "VUV", symbol: "VT", name: "Vanuatu vatu" },
  { cc: "WST", symbol: "WS$", name: "Samoan tala" },
  { cc: "XAF", symbol: "CFA", name: "Central African CFA franc" },
  { cc: "XCD", symbol: "EC$", name: "East Caribbean dollar" },
  { cc: "XDR", symbol: "SDR", name: "Special Drawing Rights" },
  { cc: "XOF", symbol: "CFA", name: "West African CFA franc" },
  { cc: "XPF", symbol: "F", name: "CFP franc" },
  { cc: "YER", symbol: "YER", name: "Yemeni rial" },
  { cc: "ZAR", symbol: "R", name: "South African rand" },
  { cc: "ZMK", symbol: "ZK", name: "Zambian kwacha" },
  { cc: "ZWR", symbol: "Z$", name: "Zimbabwean dollar" },
];

export const PLATFORMS = [
  { id: 1, code: "facebook", name: "Facebook" },
  { id: 2, code: "google", name: "Google" },
  { id: 3, code: "tiktok", name: "Tiktok" },
];

export const COLORS = [
  "#357AF6",
  "#90ed7d",
  "#f7a35c",
  "#AF52DE",
  "#388e3c",
  "#f15c80",
  "#e4d354",
  "#2b908f",
  "#f45b5b",
  "#91e8e1",
];

export const CLIENT_ID_GG = "837273913844-vojgrpbk6hikpgctc249b3l33s4dbrgo.apps.googleusercontent.com";

export const ROUTES = {
  dashboard: "/",
  application: "/",
  appOverview: "/application/overview",
  appEvents: "/application/events",
  appEventDetail: "/application/events/detail",
  appDevices: "/application/devices",
  appCrashlytics: "/application/crashlytics",
  campaignReport: "/application/campaign-report",
  campaignManagement: "/application/campaign-management",

  appDeeplink: "/link/deeplink/management",
  overviewDeeplink: "/link/deeplink/overview",
  shortlink: "/link/shortlink/management",

  engagement: "/engagement/flow",
  studio: "/engagement/flow/studio",
  flowReport: "/engagement/flow/report",
  engagementPath: "/engagement/engagement-journey",
  pushOption: "/engagement/push-option",
  pushOptionCreate: "/engagement/push-option/create",
  pushOptionEdit: "/engagement/push-option/edit/:id",
  pushOptionView: "/engagement/push-option/view/:id",
  flagConfig: "/engagement/flag-config",
  abTesting: "/engagement/ab-testing",
  experiment: "/engagement/ab-testing/experiment/:id",
  emailMarketing: "/engagement/email-marketing",
  topicPush: "/engagement/topic-push",
  userSegment: "/engagement/user-segment",
  userSegmentCreate: "/engagement/user-segment/create",
  userSegmentDetail: "/engagement/user-segment/tracking/:userSegmentId",
  userSegmentEdit: "/engagement/user-segment/edit/:id",
  unifiedCustomerProfiles: "/engagement/unified-customer-profiles",
  profileView: "/engagement/profile-view",

  accounts: "/setting/accounts",
  role: "/setting/role",
  accessToken: "/setting/access-token",

  retailerStatistics: "/retail-media/retailer/statistics",
  adInventory: "/retail-media/retailer/ad-inventory",
  adApproval: "/retail-media/retailer/ad-approval",
  advertiserStatistics: "/retail-media/advertiser/statistics",
  adCampaign: "/retail-media/advertiser/ad-campaign",
  ad: "/retail-media/advertiser/ad-campaign/ad",
  product: "/retail-media/advertiser/product",
  banner: "/retail-media/advertiser/banner",

  auditLog: "/audit-log",
};

export const PERMISSION_MODULE = {
  APPLICATION: "APPLICATION",
  DASHBOARD_OVERVIEW: "DASHBOARD_OVERVIEW",
  DASHBOARD_EVENTS: "DASHBOARD_EVENTS",
  DASHBOARD_EVENT_FLOW: "DASHBOARD_EVENT_FLOW",
  DASHBOARD_DEVICES: "DASHBOARD_DEVICES",
  DASHBOARD_CAMPAIGN_MANAGEMENT: "DASHBOARD_CAMPAIGN_MANAGEMENT",
  DASHBOARD_CAMPAIGN_REPORT: "DASHBOARD_CAMPAIGN_REPORT",
  DEEPLINK_MANAGEMENT: "DEEPLINK_MANAGEMENT",
  DEEPLINK_OVERVIEW: "DEEPLINK_OVERVIEW",
  ENGAGEMENT_FLOWS: "ENGAGEMENT_FLOWS",
  ENGAGEMENT_JOURNEY: "ENGAGEMENT_JOURNEY",
  ENGAGEMENT_PUSH_OPTION: "ENGAGEMENT_PUSH_OPTION",
  ENGAGEMENT_USER_SEGMENT: "ENGAGEMENT_USER_SEGMENT",
  ENGAGEMENT_STATISTICS: "ENGAGEMENT_STATISTICS",
  ENGAGEMENT_AB_TESTING: "ENGAGEMENT_AB_TESTING",
  EMAIL_MARKETING: "EMAIL_MARKETING",
  NOTI_TOPIC_PUSH: "NOTI_TOPIC_PUSH",
  ENGAGEMENT_UNIFIED_CUSTOMER_PROFILES: "ENGAGEMENT_UNIFIED_CUSTOMER_PROFILES",
  SETTING_ACCOUNTS: "SETTING_ACCOUNTS",
  SETTING_ROLE: "SETTING_ROLE",
  SETTING_ACCESS_TOKEN: "SETTING_ACCESS_TOKEN",
  SHORTENLINK_MANAGEMENT: "SHORTENLINK_MANAGEMENT",
  AUDIT_LOG: "AUDIT_LOG",
  RETAIL_MEDIA_RETAILER: "RETAIL_MEDIA_RETAILER",
  RETAIL_MEDIA_ADVERTISER: "RETAIL_MEDIA_ADVERTISER",
};

export const PERMISSION_ACTION = {
  CREATE: "CREATE",
  READ: "READ",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  APPROVE: "APPROVE",
};

export const ROUTE_PERMISSION = {
  [`${PERMISSION_MODULE.APPLICATION}-${PERMISSION_ACTION.READ}`]: [ROUTES.application, ROUTES.dashboard],
  [`${PERMISSION_MODULE.DASHBOARD_OVERVIEW}-${PERMISSION_ACTION.READ}`]: [ROUTES.appOverview],
  [`${PERMISSION_MODULE.DASHBOARD_EVENTS}-${PERMISSION_ACTION.READ}`]: [ROUTES.appEvents, ROUTES.appEventDetail],
  [`${PERMISSION_MODULE.DASHBOARD_DEVICES}-${PERMISSION_ACTION.READ}`]: [ROUTES.appDevices],
  [`${PERMISSION_MODULE.DASHBOARD_CAMPAIGN_REPORT}-${PERMISSION_ACTION.READ}`]: [ROUTES.campaignReport],
  [`${PERMISSION_MODULE.DASHBOARD_CAMPAIGN_MANAGEMENT}-${PERMISSION_ACTION.READ}`]: [ROUTES.campaignManagement],

  [`${PERMISSION_MODULE.DEEPLINK_MANAGEMENT}-${PERMISSION_ACTION.READ}`]: [ROUTES.appDeeplink],
  [`${PERMISSION_MODULE.SHORTENLINK_MANAGEMENT}-${PERMISSION_ACTION.READ}`]: [ROUTES.shortlink],
  [`${PERMISSION_MODULE.DEEPLINK_OVERVIEW}-${PERMISSION_ACTION.READ}`]: [ROUTES.overviewDeeplink],

  [`${PERMISSION_MODULE.ENGAGEMENT_FLOWS}-${PERMISSION_ACTION.READ}`]: [ROUTES.engagement, ROUTES.studio, ROUTES.flowReport],
  [`${PERMISSION_MODULE.ENGAGEMENT_JOURNEY}-${PERMISSION_ACTION.READ}`]: [ROUTES.engagementPath],
  [`${PERMISSION_MODULE.ENGAGEMENT_PUSH_OPTION}-${PERMISSION_ACTION.READ}`]: [ROUTES.pushOption, ROUTES.pushOptionView],
  [`${PERMISSION_MODULE.ENGAGEMENT_PUSH_OPTION}-${PERMISSION_ACTION.CREATE}`]: [ROUTES.pushOptionCreate],
  [`${PERMISSION_MODULE.ENGAGEMENT_PUSH_OPTION}-${PERMISSION_ACTION.UPDATE}`]: [ROUTES.pushOptionEdit],
  [`${PERMISSION_MODULE.ENGAGEMENT_USER_SEGMENT}-${PERMISSION_ACTION.READ}`]: [
    ROUTES.userSegment,
    ROUTES.userSegmentDetail,
  ],
  [`${PERMISSION_MODULE.ENGAGEMENT_USER_SEGMENT}-${PERMISSION_ACTION.CREATE}`]: [ROUTES.userSegmentCreate],
  [`${PERMISSION_MODULE.ENGAGEMENT_USER_SEGMENT}-${PERMISSION_ACTION.UPDATE}`]: [ROUTES.userSegmentEdit],
  [`${PERMISSION_MODULE.ENGAGEMENT_UNIFIED_CUSTOMER_PROFILES}-${PERMISSION_ACTION.READ}`]: [
    ROUTES.unifiedCustomerProfiles,
    ROUTES.profileView,
  ],
  [`${PERMISSION_MODULE.ENGAGEMENT_AB_TESTING}-${PERMISSION_ACTION.READ}`]: [
    ROUTES.abTesting,
    ROUTES.flagConfig,
    ROUTES.experiment,
  ],
  [`${PERMISSION_MODULE.EMAIL_MARKETING}-${PERMISSION_ACTION.READ}`]: [ROUTES.emailMarketing],
  [`${PERMISSION_MODULE.NOTI_TOPIC_PUSH}-${PERMISSION_ACTION.READ}`]: [ROUTES.topicPush],
  [`${PERMISSION_MODULE.AUDIT_LOG}-${PERMISSION_ACTION.READ}`]: [ROUTES.auditLog],
  [`${PERMISSION_MODULE.SETTING_ACCOUNTS}-${PERMISSION_ACTION.READ}`]: [ROUTES.accounts],
  [`${PERMISSION_MODULE.SETTING_ROLE}-${PERMISSION_ACTION.READ}`]: [ROUTES.role],
  [`${PERMISSION_MODULE.RETAIL_MEDIA_RETAILER}-${PERMISSION_ACTION.READ}`]: [
    ROUTES.retailerStatistics,
    ROUTES.adInventory,
    ROUTES.adApproval,
  ],
  [`${PERMISSION_MODULE.RETAIL_MEDIA_ADVERTISER}-${PERMISSION_ACTION.READ}`]: [
    ROUTES.advertiserStatistics,
    ROUTES.adCampaign,
    ROUTES.ad,
    ROUTES.product,
    ROUTES.banner,
  ],
  [`${PERMISSION_MODULE.SETTING_ACCESS_TOKEN}-${PERMISSION_ACTION.READ}`]: [ROUTES.accessToken],
};

export const WIDGET_TYPE = {
  scoreStatistic: "score-statistic",
  statistic: "statistic",
  pie: "pie",
  bar: "bar",
  stackedBar: "stacked-bar",
  line: "line",
  table: "table",
};

export const RANGE_PRESETS = [
  { label: "Last 7 Days", value: [dayjs().add(-6, "d"), dayjs()] },
  { label: "Last 14 Days", value: [dayjs().add(-13, "d"), dayjs()] },
  { label: "Last 30 Days", value: [dayjs().add(-29, "d"), dayjs()] },
  { label: "Last 90 Days", value: [dayjs().add(-89, "d"), dayjs()] },
];

export const CAMPAIGN_METRIC_CHART_OPTION = [
  { value: "click", label: "Click", type: "metric" },
  { value: "user_referrer", label: "User referrer", type: "metric" },
  { value: "user_referral", label: "User referral", type: "metric" },
];

export const METRIC_CHART_OPTION = [
  { value: "event_count", label: "Event count", type: "metric" },
  { value: "event_unique_users", label: "Event unique users", type: "metric" },
];

export const CHART_SELECT_TYPE = {
  BY_EVENT: "BY_EVENT",
  BY_EVENT_KEY: "BY_EVENT_KEY",
  BY_EVENT_VALUE: "BY_EVENT_VALUE",
};

export const DEFAULT_EMAIL_TEMPLATE = {
  subject: "",
  subTitle: "",
  content: {
    type: "page",
    data: {
      value: {
        breakpoint: "480px",
        headAttributes: "",
        "font-size": "14px",
        "line-height": "1.7",
        headStyles: [],
        fonts: [],
        responsive: true,
        // Helvetica, sans-serif: font dự phòng khi trình đọc email không có Arial
        "font-family": "Arial, Helvetica, sans-serif",
        "text-color": "#000000",
      },
    },
    attributes: { "background-color": "#FFFFFF", width: "600px", "css-class": "mjml-body" },
    children: [],
  },
};

export const MODAL_TYPE_CX = {
  EVENT: "EVENT",
  CONDITION: "CONDITION",
  REACHABILITY: "REACHABILITY",
  SEGMENT: "SEGMENT",
  APP_PUSH: "APP_PUSH",
  SMS: "SMS",
  EMAIL: "EMAIL",
  WAIT: "WAIT",
  DATETIME: "DATETIME",
  WEBHOOK: "WEBHOOK",
  CHATBOT: "CHATBOT",
  EVENT_HISTORY: "EVENT_HISTORY",
  EMAIL_CAMPAIGN: "EMAIL_CAMPAIGN",
};

export const FREQUENCY_TYPE = [
  { label: "Dont' repeat", value: "DONT_REPEAT" },
  { label: "Daily", value: "DAILY" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Monthly", value: "MONTHLY" },
  { label: "Yearly", value: "YEARLY" },
  { label: "Custom", value: "CUSTOM" },
];

export const SHORT_FREQUENCY_TYPE = [
  { label: "Daily", value: "DAILY" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Monthly", value: "MONTHLY" },
  { label: "Yearly", value: "YEARLY" },
];

export const DAY_OF_WEEK = ["M", "T", "W", "T", "F", "S", "S"];

export const VARIABLE_OPTIONS = [
  { value: "${name}", label: "Name", approxLength: 20, regexStr: "\\$\\{name\\}" },
  { value: "${phone}", label: "Phone", approxLength: 10, regexStr: "\\$\\{phone\\}" },
  { value: "${email}", label: "Email", approxLength: 30, regexStr: "\\$\\{email\\}" },
];

export const CUSTOM_BLOCK_TYPE = {
  PAGE: "page",
  VARIABLE: "variable",
  DEEPLINK: "deeplink",
  TEXT: "textcustom",
  IMAGE: "imageCustom",
};

export const USER_SEGMENT_STATUS_OPTION = [
  { value: 1, label: "Active" },
  { value: 3, label: "Processing" },
  { value: 4, label: "Error" },
];

export const OPTION_MOBILE = [
  { value: "MOBILE", label: "All" },
  { value: "IOS", label: "iOS" },
  { value: "ANDROID", label: "Android" },
];

export const PLATFORM_OS = {
  WEB: "WEB",
  MOBILE: "MOBILE",
};

export const REFERRAL_GRID_ITEM = {
  CHART: "CHART",
  SUMMARY_TABLE: "SUMMARY",
  DETAIL_TABLE: "DETAIL",
};

export const getOptionDefaultChart = (t) => ({
  title: { text: "" },
  credits: { enabled: false },
  responsive: {
    rules: [
      {
        condition: { maxWidth: 500 },
        chartOptions: { legend: { layout: "horizontal", align: "center", verticalAlign: "bottom" } },
      },
    ],
  },
  xAxis: { showEmpty: false },
  yAxis: { showEmpty: false },
  colors: COLORS,
  lang: {
    noData: `
            <span>
              <svg width="136" height="112" viewBox="0 0 136 112" xmlns="http://www.w3.org/2000/svg">
                <path d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z" fill="#AEB8C2"></path>
                <path d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z" fill="url(#linearGradient-1)" transform="translate(13.56)"></path>
                <path d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z" fill="#F5F5F7"></path>
                <path d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z" fill="#DCE0E6"></path> n
              </svg>
              <span style="display: flex; justify-content: center; font-size: 16px; color: #AEB8C2; margin-top: 12px;">${t(
                "No data",
              )}</span>
            </span>
           `,
    viewFullscreen: t("View in full screen"),
    printChart: t("Print chart"),
    downloadPNG: t("Download PNG image"),
    downloadJPEG: t("Download JPEG image"),
    downloadPDF: t("Download PDF document"),
    downloadSVG: t("Download SVG vector image"),
  },
  noData: {
    position: { align: "center", verticalAlign: "middle" },
    useHTML: true,
  },
});

export const LANGUAGE = {
  EN: "en",
  VI: "vi",
};

export const RUNNING_STATUS = {
  RUNNING: "RUNNING",
  STOP: "STOP",
  PAUSE: "PAUSE",
};

export const RUNNING_STATUS_COLOR = {
  [RUNNING_STATUS.RUNNING]: "#1677ff",
  [RUNNING_STATUS.PAUSE]: "#8c8c8c",
};

export const INITIAL_EXPERIMENT_FORM = {
  variants: [
    { variant_values: [{}], variant_weight: 1, name: "Baseline" },
    { variant_values: [{}], variant_weight: 1, name: "Variant 1" },
  ],
};

export const FALLBACK_IMAGE =
  "data:image/png;base64,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";

export const PLATFORM = {
  MOBILE: "MOBILE",
  IOS: "IOS",
  ANDROID: "ANDROID",
  WEB: "WEB",
};

export const PLATFORM_ICON = {
  [PLATFORM.MOBILE]: <MobileOutlined />,
  [PLATFORM.IOS]: <AppleOutlined />,
  [PLATFORM.ANDROID]: <AndroidOutlined />,
  [PLATFORM.WEB]: <DesktopOutlined />,
};

export const getPlatformProps = (t, platform) => {
  const icon = PLATFORM_ICON[platform];
  const options = [
    {
      value: PLATFORM.MOBILE,
      label: (
        <div className="flex item-center gap-1">
          {PLATFORM_ICON[PLATFORM.MOBILE]} {t("Mobile")}
        </div>
      ),
    },
    {
      value: PLATFORM.IOS,
      label: (
        <div className="flex item-center gap-1">
          {PLATFORM_ICON[PLATFORM.IOS]} {"iOS"}
        </div>
      ),
    },
    {
      value: PLATFORM.ANDROID,
      label: (
        <div className="flex item-center gap-1">
          {PLATFORM_ICON[PLATFORM.ANDROID]} {"Android"}
        </div>
      ),
    },
    {
      value: PLATFORM.WEB,
      label: (
        <div className="flex item-center gap-1">
          {PLATFORM_ICON[PLATFORM.WEB]} {"Web"}
        </div>
      ),
    },
  ];
  const label = options.find((o) => o.value === platform)?.label;
  return { options, icon, label };
};

export const NOTIFICATION_TYPE = {
  NEWS: "NEWS",
  INBOX: "INBOX",
};

export const AD_TYPE = {
  PRODUCT: "PRODUCT",
  BANNER: "BANNER",
};

export const MODULE = {
  RMP: "RMP",
};

export const RMP_ROLE = {
  RETAILER: "RETAILER",
  ADVERTISER: "ADVERTISER",
};

export const PARTNER_SETTING_KEY = {
  ENABLE_AUTO_APPROVAL_DEEPLINK: "ENABLE_AUTO_APPROVAL_DEEPLINK",
  ENABLE_AUTO_APPROVAL_ACCOUNT: "ENABLE_AUTO_APPROVAL_ACCOUNT",
};

export const CTA_TYPE = {
  IN_APP: "IN_APP",
  OUT_APP: "OUT_APP",
};

export const OPTIONS_CREATED_FROM = [
  { label: "Portal", value: "portal" },
  { label: "SDK", value: "partner" },
  { label: "JS SDK", value: "partner_jssdk" },
];

export const INVENTORY_TYPE = {
  VIDEO: "VIDEO",
  INTERSTITIAL: "INTERSTITIAL",
  BANNER: "BANNER",
  MODAL: "MODAL",
  NATIVE: "NATIVE",
};

export const getInventoryType = (t) => [
  { label: t("Native"), value: INVENTORY_TYPE.NATIVE },
  { label: t("Banner"), value: INVENTORY_TYPE.BANNER },
  { label: t("Interstitial"), value: INVENTORY_TYPE.INTERSTITIAL },
  { label: t("Modal"), value: INVENTORY_TYPE.MODAL },
  { label: t("Video"), value: INVENTORY_TYPE.VIDEO },
];

export const UNAUTH_ROUTE = {
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  VERIFICATION: "/verification",
  LOGIN: "/login",
  LOGIN_VPBANK: "/login/vpbank",
  RESET_PASSWORD: "/reset-password",
};

export const DEMO_APP_ID = "demo";
